import { useParams, useNavigate } from 'react-router-dom';
import appConfig from '../config/app-config';

const { address, key } = appConfig.apis.legalApiEnv;

export const useFileMapping = () => {
    const navigate = useNavigate();

    const {
        page = '0',
        pageSize = '200',
        field: fieldSorted = 'process',
        order: orderSorted = 'ASC',
        filter,
    } = useParams();

    let searchTerm = '';
    let extractableFilter = '';
    let syncedFilter = '';
    let linkedFilter = '';
    if (filter) {
        const searchMatch = filter.match(/s=(.*?);/);
        if (searchMatch) searchTerm = decodeURIComponent(searchMatch[1]);
        const extractableMatch = filter.match(/e=(.*?);/);
        if (extractableMatch) extractableFilter = decodeURIComponent(extractableMatch[1]);
        const syncedMatch = filter.match(/y=(.*?);/);
        if (syncedMatch) syncedFilter = decodeURIComponent(syncedMatch[1]);
        const linkedMatch = filter.match(/l=(.*?);/);
        if (linkedMatch) linkedFilter = decodeURIComponent(linkedMatch[1]);
    }

    const buildFilter = (search: string, extractable: string, synced: string, linked: string) => {
        let f = '';
        if (search) f += `s=${encodeURIComponent(search)};`;
        if (extractable) f += `e=${encodeURIComponent(extractable)};`;
        if (synced) f += `y=${encodeURIComponent(synced)};`;
        if (linked) f += `l=${encodeURIComponent(linked)};`;
        return f || undefined;
    };

    const basePath = '/legal/files';
    const buildUrl = (p: string, ps: string, f: string, o: string, fl?: string) =>
        fl ? `${basePath}/${p}/${ps}/${f}/${o}/${fl}` : `${basePath}/${p}/${ps}/${f}/${o}`;

    const extractableParam = extractableFilter ? `&extractable=${extractableFilter}` : '';
    const syncedParam = syncedFilter ? `&synced=${syncedFilter}` : '';
    const linkedParam = linkedFilter ? `&linked=${linkedFilter}` : '';
    const url = `${address}/files/page-list?page=${page}&size=${pageSize}&search=${encodeURIComponent(searchTerm)}&sort=${fieldSorted},${orderSorted}${extractableParam}${syncedParam}${linkedParam}`;

    const pageChanged = (p: number) => navigate(buildUrl(String(p), pageSize, fieldSorted, orderSorted, buildFilter(searchTerm, extractableFilter, syncedFilter, linkedFilter)));
    const pageSizeChanged = (ps: number) => navigate(buildUrl('0', String(ps), fieldSorted, orderSorted, buildFilter(searchTerm, extractableFilter, syncedFilter, linkedFilter)));
    const pageSorted = (field: string, order: 'ASC' | 'DESC') => navigate(buildUrl(page, pageSize, field, order, buildFilter(searchTerm, extractableFilter, syncedFilter, linkedFilter)));
    const searchChanged = (search: string) => navigate(buildUrl('0', pageSize, fieldSorted, orderSorted, buildFilter(search, extractableFilter, syncedFilter, linkedFilter)));
    const extractableChanged = (value: string) => navigate(buildUrl('0', pageSize, fieldSorted, orderSorted, buildFilter(searchTerm, value, syncedFilter, linkedFilter)));
    const syncedChanged = (value: string) => navigate(buildUrl('0', pageSize, fieldSorted, orderSorted, buildFilter(searchTerm, extractableFilter, value, linkedFilter)));
    const linkedChanged = (value: string) => navigate(buildUrl('0', pageSize, fieldSorted, orderSorted, buildFilter(searchTerm, extractableFilter, syncedFilter, value)));
    const onFilterClean = () => navigate(buildUrl('0', pageSize, fieldSorted, orderSorted));

    return {
        page, pageSize, fieldSorted, orderSorted, searchTerm,
        extractableFilter, syncedFilter, linkedFilter,
        url, API_KEY: key, API_ADDRESS: address,
        pageChanged, pageSizeChanged, pageSorted,
        searchChanged, extractableChanged, syncedChanged, linkedChanged, onFilterClean,
    };
};
